export default function Onboarding() {
  return (
    <section
      className="padding-y"
      style={{
        position: "relative",
        paddingBottom: "calc(52.58064516129032% + 41px)",
        height: "0",
        width: "90%",
        margin: "0 auto",
      }}
    >
      <iframe
        src="https://demo.arcade.software/dDAyEWmly66IGRHBD2YW?embed&embed_mobile=inline&embed_desktop=inline&show_copy_link=true"
        title="Rhino Recon Onboarding Demo"
        frameBorder="0"
        loading="lazy"
        allowFullScreen
        allow="clipboard-write"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          colorScheme: "light",
        }}
      />
    </section>
  );
}
